module.exports = __webpack_public_path__ + "static/media/spin-the-wheel.6afe5248.jpg";